// <sm-sticky-atc>: shows the bar once #sm-main-atc has scrolled out of view (HANDOFF 7.2).
// <sm-plan-dropdown>: plan picker pill + listbox (7.3), single source of truth is the main
// plan radio group; selecting here just clicks the matching radio there.
import { on } from './sm-core.js';

class SmStickyAtc extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.getAttribute('target'));
    if (!this.target) return;
    this.io = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', passed);
        this.setAttribute('aria-hidden', String(!passed));
        document.body.style.setProperty('--sm-sticky-h', passed ? `${this.offsetHeight}px` : '0px');
      },
      { rootMargin: '0px' }
    );
    this.io.observe(this.target);

    this.offPlanChanged = on('sm:plan:changed', (e) => this.render(e.detail));
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.offPlanChanged?.();
    document.body.style.removeProperty('--sm-sticky-h');
  }

  render(detail) {
    const label = this.querySelector('[data-sticky-plan-label]');
    const dropdownLabel = this.querySelector('[data-dropdown-label]');
    if (label && detail?.label) label.textContent = detail.label;
    if (dropdownLabel && detail?.label) dropdownLabel.textContent = detail.label;
  }
}
if (!customElements.get('sm-sticky-atc')) customElements.define('sm-sticky-atc', SmStickyAtc);

class SmPlanDropdown extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-dropdown-trigger]');
    this.list = this.querySelector('[data-dropdown-list]');
    if (!this.trigger || !this.list) return;
    this.options = [...this.list.querySelectorAll('[data-dropdown-option]')];

    this.onTriggerClick = () => this.toggle();
    this.onDocClick = (e) => {
      if (!this.contains(e.target)) this.close();
    };
    this.onKeydown = (e) => this.handleKeydown(e);

    this.trigger.addEventListener('click', this.onTriggerClick);
    document.addEventListener('click', this.onDocClick);
    this.addEventListener('keydown', this.onKeydown);
    this.options.forEach((opt) => {
      opt.addEventListener('click', () => this.select(opt));
    });
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
    document.removeEventListener('click', this.onDocClick);
  }

  toggle() {
    this.list.hidden ? this.open() : this.close();
  }

  open() {
    this.list.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.options[0]?.focus();
  }

  close() {
    this.list.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
      this.trigger.focus();
      return;
    }
    if (this.list.hidden) return;
    const focused = this.options.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      (this.options[focused + 1] || this.options[0])?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      (this.options[focused - 1] || this.options[this.options.length - 1])?.focus();
    } else if (e.key === 'Enter' && focused > -1) {
      this.select(this.options[focused]);
    }
  }

  select(option) {
    const planId = option.dataset.planId;
    const radio = document.getElementById(`sm-plan-${planId}`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.close();
    this.trigger.focus();
  }
}
if (!customElements.get('sm-plan-dropdown')) customElements.define('sm-plan-dropdown', SmPlanDropdown);

// Bar CTA submits the main PDP buy form (whatever its block id), so plan + variant stay in sync.
document.addEventListener('click', (e) => {
  const cta = e.target.closest('[data-sticky-cta]');
  if (!cta) return;
  e.preventDefault();
  const form = document.querySelector('sm-pdp-offer-form form, .sm-pdp-offer__buybox form, form[action*="/cart/add"]');
  if (form?.requestSubmit) form.requestSubmit(); else form?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
});
